import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { Star, ChevronLeft, ChevronRight, Quote } from 'lucide-react';
const testimonios = [{
  id: 1,
  name: 'María González',
  location: 'Buenos Aires, Argentina',
  text: '¡Una maravilla! Mis hijos llevan días entretenidos. Imprimí solo los personajes que más les gustan y ahorré muchísimo dinero comparado con comprar los libros físicos.'
}, {
  id: 2,
  name: 'Carolina Pérez',
  location: 'Córdoba, Argentina',
  text: 'Lo compré para un viaje largo y fue la mejor decisión. Llevamos una carpeta llena de hojas y colores. Cero pantallas durante todo el trayecto.'
}, {
  id: 3,
  name: 'Ana Martínez',
  location: 'Rosario, Argentina',
  text: 'La calidad de los dibujos es excelente. La descarga fue inmediata y súper fácil de organizar. A mi hija le encantó la sección de princesas.'
}, {
  id: 4,
  name: 'Lucía Fernández',
  location: 'Mendoza, Argentina',
  text: 'Me encanta que si se equivocan o rompen la hoja, simplemente imprimo otra. Es una inversión que dura para siempre. Muy completo el pack.'
}, {
  id: 5,
  name: 'Daniela Ruiz',
  location: 'La Plata, Argentina',
  text: 'Buscaba algo para alejar a mis niños de la tablet y esto funcionó perfecto. Nos sentamos a colorear juntos en familia. Vale cada centavo.'
}];
export const Testimonios: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [direction, setDirection] = useState(0);
  useEffect(() => {
    const timer = setInterval(() => {
      setDirection(1);
      setCurrentIndex(prev => (prev + 1) % testimonios.length);
    }, 5500);
    return () => clearInterval(timer);
  }, [currentIndex]);
  const nextSlide = () => {
    setDirection(1);
    setCurrentIndex(prev => (prev + 1) % testimonios.length);
  };
  const prevSlide = () => {
    setDirection(-1);
    setCurrentIndex(prev => (prev - 1 + testimonios.length) % testimonios.length);
  };
  const variants = {
    enter: (direction: number) => ({
      x: direction > 0 ? 80 : -80,
      opacity: 0
    }),
    center: {
      x: 0,
      opacity: 1
    },
    exit: (direction: number) => ({
      x: direction < 0 ? 80 : -80,
      opacity: 0
    })
  };
  const t = testimonios[currentIndex];
  return <section className="py-8 px-4 bg-cream-dark/50 overflow-hidden" data-id="element-163">
      <div className="max-w-2xl mx-auto" data-id="element-164">
        <h2 className="font-rounded font-bold text-[2rem] sm:text-4xl text-violet text-center leading-tight mb-8" data-id="element-165">
          Lo que dicen quienes{' '}
          <span className="text-gold-dark" data-id="element-166">ya la descargaron</span>
        </h2>

        <div className="relative" data-id="element-167">
          <AnimatePresence initial={false} custom={direction} mode="wait" data-id="element-168">
            <motion.div key={currentIndex} custom={direction} variants={variants} initial="enter" animate="center" exit="exit" transition={{
            duration: 0.35,
            ease: 'easeInOut'
          }} data-id="element-169">
              <div className="bg-white p-6 sm:p-8 rounded-3xl border-2 border-gold/40 shadow-2xl relative" data-id="element-170">
                <Quote className="absolute top-4 right-4 text-gold/30 w-12 h-12" data-id="element-171" />

                <div className="flex gap-0.5 mb-3" data-id="element-172">
                  {[...Array(5)].map((_, i) => <Star key={i} className="w-5 h-5 fill-gold-dark text-gold-dark" data-id="element-173" />)}
                </div>

                <p className="text-violet text-base sm:text-lg leading-relaxed font-semibold mb-4" data-id="element-174">
                  "{t.text}"
                </p>

                <div className="border-t-2 border-dashed border-cream-dark pt-3" data-id="element-175">
                  <p className="font-rounded font-bold text-violet text-base sm:text-lg leading-tight" data-id="element-176">
                    {t.name}
                  </p>
                  <p className="text-xs sm:text-sm text-textsoft font-semibold" data-id="element-177">
                    {t.location}
                  </p>
                </div>
              </div>
            </motion.div>
          </AnimatePresence>

          <div className="flex items-center justify-center gap-4 mt-5" data-id="element-178">
            <button onClick={prevSlide} className="bg-violet text-cream p-2 rounded-full shadow-md hover:bg-violet-light transition-colors" aria-label="Anterior" data-id="element-179">
              <ChevronLeft size={20} data-id="element-180" />
            </button>

            <div className="flex gap-1.5" data-id="element-181">
              {testimonios.map((_, idx) => <button key={idx} onClick={() => {
              setDirection(idx > currentIndex ? 1 : -1);
              setCurrentIndex(idx);
            }} className={`h-2 rounded-full transition-all ${idx === currentIndex ? 'bg-gold-dark w-6' : 'bg-gold/40 w-2'}`} aria-label={`Ir al testimonio ${idx + 1}`} data-id="element-182" />)}
            </div>

            <button onClick={nextSlide} className="bg-violet text-cream p-2 rounded-full shadow-md hover:bg-violet-light transition-colors" aria-label="Siguiente" data-id="element-183">
              <ChevronRight size={20} data-id="element-184" />
            </button>
          </div>
        </div>
      </div>
    </section>;
};